module.exports = __webpack_public_path__ + "img/91.e3ae9db8.jpg";